<template>
  <!-- 即時影像 -->

  <!-- <div class="row g-2 mb-2"> -->
    <div class="col">
      <div class="card card-clean h-100">
        <div class="card-header bg-white border-0 fw-bold text-indigo h5">
          設備地圖
        </div>
        <div class="card-body p-2" >
        <MapMap :scenicAreaId='selectedScenicAreaId'></MapMap>

        </div>
      </div>
    </div>
  <!-- </div> -->
</template>
    
<script>
import { mapState, mapGetters } from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import MapMap from '../map/index'


export default {
  components: {
    MapMap
  },
  props: ['selectedScenicAreaId'],
  data() {
    return {
 
    };
  },
  methods: {
    // async getToiletData() {
    //   // 洗手乳、異味偵測
    //   await this.$store.dispatch('toiletMgt/getAllScenicToiletData')
    // },
    // async getAllData() {
    //   await this.getToiletData();
    //   await this.$store.dispatch('toiletMgt/getTioletErrorDevice')
    //   await this.$store.dispatch('emergencyEvent/getEmergencyButton')

    // }
   
  },
  computed:{
    ...mapState('scenicArea', {scenicAreaList: 'allscenicArea'}),
    ...mapState('elasticMonitor', {vehicleAndPeople: 'vehicleAndPeople'}),
    ...mapState('elasticMonitor', {totalVehicleAndPeople: 'totalVehicleAndPeople'}),
    ...mapState('weatherMonitor', {cwbWeather: 'allWeather'}),
    ...mapGetters('toiletMgt', {isOdorAlert: 'getOdorAlert'}),
    ...mapGetters('toiletMgt', {isHandsanitizerAlert: 'getHandsanitizerAlert'}),
  
  },
  watch: {
    
  },
  async mounted() {
    // await this.$store.dispatch('videoCamera/getCCTV')    
    // this.getAllData()
  },
};
</script>
    